(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('ExclusiveActionsController', exclusiveActionsController);

  exclusiveActionsController.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'CompanyService', 'NotificationService'];

  function exclusiveActionsController ($http, $state, AuthenticationService, $rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.exclusiveSett');

    var vmExclusiveCtrl = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmExclusiveCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmExclusiveCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmExclusiveCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
